<template>
  <v-card outlined class="mx-3" style="border-bottom: thin solid rgba(0, 0, 0, 0.12)">

    <v-data-table
      :headers="headers"
      :items="data"
      :items-per-page="1000"
      class="custom-report-table"
      v-if="data.length"
      hide-default-footer
    >
      <template slot="header">
        <thead class="thead-custom">
          <tr>
            <th></th>
            <th class="text-center" colspan="2">Số Lượng</th>
            <th class="text-center" colspan="2">Tỉ lệ chốt</th>
            <th class="text-center" colspan="2">Doanh thu</th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.density="{ item }">
        {{ +item.density + '%' }}
      </template>

      <template v-slot:item.hotLatch="{ item }">
        {{ +item.hotLatch + '%' }}
      </template>

      <template v-slot:item.generalLatch="{ item }">
        {{ +item.generalLatch + '%' }}
      </template>

      <template v-slot:item.hotTurnOver="{ item }">
        {{ formatPrice(item.hotTurnOver) }}
      </template>

      <template v-slot:item.generalTurnOver="{ item }">
        {{ formatPrice(item.generalTurnOver) }}
      </template>

    </v-data-table>
    <common-no-result
      v-if="!data.length"
    />
  </v-card>

</template>

<script>
import { formatPrice } from '@/helpers/utils'

export default {
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      headers: [
        { text: 'Nguồn', align: 'center', value: 'name' },
        { text: 'Số lượng', align: 'center', value: 'countContacts' },
        { text: 'Tỉ trọng', align: 'center', value: 'density' },
        { text: 'Tỉ lệ chốt nóng', align: 'center', value: 'hotLatch' },
        { text: 'Tỉ lệ chốt', align: 'center', value: 'generalLatch' },
        { text: 'Doanh thu chốt nóng', align: 'center', value: 'hotTurnOver' },
        { text: 'Doanh thu khởi tạo', align: 'center', value: 'generalTurnOver' },
      ],
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .custom-report-table {
    tr th:not(:last-child), tr td:not(:last-child) {
      border-right: thin solid rgba(0, 0, 0, 0.12);
    }
    .thead-custom tr th {
      border-top: thin solid rgba(0, 0, 0, 0.12);
      text-transform: uppercase;
      font-weight: 500;
      &:first-child {
        visibility: hidden;
      }
    }
    thead tr th {
      background-color: #0089d4;
      color: #ffffff!important;
      i {
        color: #ffffff!important;
      }
    }
  }
</style>